import toPairs from 'lodash.topairs';

const createRules = kind =>
  toPairs(kind).reduce(
    (rules, [size, rems]) =>
      (rules += `
        &.${size} {
          height: ${rems};
          width: ${rems};
        }
      `),
    '',
  );

const dimensions = {
  topbarHeight: '50px',
};

const block = {
  xs: '0.25rem',
  sm: '0.5rem',
  md: '1rem',
  lg: '1.25rem',
  xl: '1.625rem',
};

const coin = {
  xs: '1.5rem',
  sm: '2rem',
  md: '2.5rem',
  lg: '3rem',
  xl: '3.5rem',
};

const icon = {
  xs: '0.75rem',
  sm: '1rem',
  md: '1.25rem',
  lg: '1.5rem',
  xl: '2rem',
};

const state = {
  xs: '0.5rem',
  sm: '.75rem',
  md: '1rem',
  lg: '1.25rem',
  xl: '1.5rem',
};

const type = {
  xs: '0.25em',
  sm: '0.5em',
  md: '1em',
  lg: '1.25em',
  xl: '1.625em',
};

export default {
  block,
  coin,
  createRules,
  dimensions,
  icon,
  state,
  type,
};
